import React from "react";
import { STORE_INFO } from "../mock";
import { MapPin, Phone, Clock, Mail, BadgeCheck } from "lucide-react";
import { Button } from "../components/ui/button";
import BusinessCard from "../components/BusinessCard";

const About = () => {
  return (
    <div>
      <section className="bg-[#0b2960] text-white py-14">
        <div className="max-w-7xl mx-auto px-4 text-center">
          <div className="text-xs uppercase tracking-widest font-bold text-[#ff5a5f]">Notre magasin</div>
          <h1 className="text-3xl md:text-5xl font-black mt-1">Bienvenue chez EDS ELECTROMENAGER</h1>
          <p className="mt-3 text-neutral-200 max-w-2xl mx-auto">Spécialiste de l'électroménager occasion & neuf, du dépannage et du service à Marseille.</p>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-4 py-14 grid md:grid-cols-2 gap-10 items-center">
        <div className="relative">
          <div className="absolute -inset-3 bg-[#e11d24]/10 rounded-2xl -rotate-2" />
          <img src={STORE_INFO.storePhoto} alt="Magasin EDS ELECTROMENAGER" className="relative w-full rounded-xl shadow-xl object-cover aspect-[4/3]" />
          <div className="absolute -bottom-8 -right-4 md:-right-10 hidden sm:block">
            <BusinessCard rotate="rotate-6" />
          </div>
        </div>
        <div>
          <h2 className="text-2xl md:text-3xl font-extrabold text-[#0b2960]">Notre histoire</h2>
          <p className="mt-3 text-neutral-700 leading-relaxed">
            Situé au cœur de Marseille (10ᵉ arrondissement), EDS ELECTROMENAGER est votre partenaire de confiance pour tout équiper votre maison. Nous sélectionnons les meilleures marques pour vous proposer un large choix de réfrigérateurs, lave-linge, TV, hifi, cuisson et petit électroménager.
          </p>
          <p className="mt-3 text-neutral-700 leading-relaxed">
            Notre équipe passionnée vous conseille pour trouver le produit idéal selon vos besoins et votre budget. Neuf ou occasion, nous garantissons la qualité et le meilleur prix.
          </p>
          <ul className="mt-5 space-y-2">
            {["Électroménager · Dépannage · Service", "Techniciens qualifiés à domicile", "Livraison rapide sur Marseille", "Grandes marques : Samsung, Bosch, Siemens..."].map((t) => (
              <li key={t} className="flex items-center gap-2 text-sm text-neutral-700"><BadgeCheck className="h-4 w-4 text-[#e11d24]" /> {t}</li>
            ))}
          </ul>
          <div className="mt-5 inline-block bg-neutral-100 rounded-md px-3 py-2 text-xs text-neutral-600">
            <span className="font-semibold text-neutral-800">SIRET :</span> {STORE_INFO.siret}
          </div>
        </div>
      </section>

      <section className="bg-white border-y border-neutral-200 py-14">
        <div className="max-w-7xl mx-auto px-4 grid md:grid-cols-3 gap-6">
          <div className="bg-neutral-50 rounded-xl p-6">
            <MapPin className="h-6 w-6 text-[#e11d24]" />
            <h3 className="mt-3 font-bold text-[#0b2960]">Adresse</h3>
            <p className="text-sm text-neutral-700 mt-1">{STORE_INFO.address}</p>
          </div>
          <div className="bg-neutral-50 rounded-xl p-6">
            <Phone className="h-6 w-6 text-[#e11d24]" />
            <h3 className="mt-3 font-bold text-[#0b2960]">Téléphone</h3>
            <a href={`tel:${STORE_INFO.phone.replace(/\s/g, "")}`} className="block text-sm text-neutral-700 mt-1 hover:text-[#e11d24]">{STORE_INFO.phone}</a>
            <a href={`mailto:${STORE_INFO.email}`} className="flex items-center gap-1 text-sm text-neutral-700 mt-1 hover:text-[#e11d24]"><Mail className="h-4 w-4" /> {STORE_INFO.email}</a>
          </div>
          <div className="bg-neutral-50 rounded-xl p-6">
            <Clock className="h-6 w-6 text-[#e11d24]" />
            <h3 className="mt-3 font-bold text-[#0b2960]">Horaires</h3>
            <ul className="text-sm text-neutral-700 mt-1 space-y-0.5">
              {STORE_INFO.hours.map((h) => (
                <li key={h.day} className="flex justify-between gap-3">
                  <span className="font-semibold">{h.day}</span>
                  <span className={h.time === "Fermé" ? "text-[#e11d24]" : ""}>{h.time}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-4 py-14">
        <h2 className="text-2xl md:text-3xl font-extrabold text-[#0b2960] text-center">Nous trouver</h2>
        <p className="text-center text-neutral-600 mt-2">Venez découvrir notre magasin à Marseille</p>
        <div className="mt-6 rounded-xl overflow-hidden border border-neutral-200 shadow-lg aspect-[16/8]">
          <iframe
            title="Carte EDS ELECTROMENAGER"
            src="https://www.google.com/maps?q=304+avenue+de+la+Capelette,+13010+Marseille&output=embed"
            className="w-full h-full"
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>
        <div className="text-center mt-6">
          <a href={`tel:${STORE_INFO.phone.replace(/\s/g, "")}`}>
            <Button className="bg-[#e11d24] hover:bg-[#b8171d] h-12 px-6 font-bold"><Phone className="h-4 w-4 mr-2" /> Appeler le magasin</Button>
          </a>
        </div>
      </section>
    </div>
  );
};

export default About;
